(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
  var aboutSection = document.querySelector('.about');
  if (aboutSection) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    observer.observe(aboutSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var C = 2 * Math.PI * 70;

    document.querySelectorAll('[id^="stats-"]').forEach(function(section) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && section.dataset.animated === 'false') {
            section.dataset.animated = 'true';
            animateAll(section);
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(section);
    });

    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

    function animateAll(section) {
      var items = section.querySelectorAll('.stats__item');
      var duration = 1500;
      var start = performance.now();

      function tick(now) {
        var t = Math.min((now - start) / duration, 1);
        var e = easeOut(t);

        items.forEach(function(item) {
          var type = item.dataset.chartType;

          if (type === 'dual') {
            var pVal = parseFloat(item.dataset.primary) || 0;
            var sVal = parseFloat(item.dataset.secondary) || 0;
            var pArc = (pVal * e / 100) * C;
            var sArc = (sVal * e / 100) * C;

            var pCircle = item.querySelector('.stats__arc--primary');
            var sCircle = item.querySelector('.stats__arc--secondary');
            pCircle.setAttribute('stroke-dasharray', pArc + ' ' + (C - pArc));
            sCircle.setAttribute('stroke-dasharray', sArc + ' ' + (C - sArc));
            sCircle.setAttribute('stroke-dashoffset', -pArc);

            var centerNum = item.querySelector('.stats__center-num');
            if (centerNum) centerNum.textContent = Math.round(pVal * e);

            var vals = item.querySelectorAll('.stats__legend-val');
            if (vals[0]) vals[0].textContent = Math.round(pVal * e) + '%';
            if (vals[1]) vals[1].textContent = Math.round(sVal * e) + '%';

          } else if (type === 'quad') {
            var segs = item.querySelectorAll('.stats__arc-seg');
            var vals = item.querySelectorAll('.stats__legend-val');
            var percents = [];
            segs.forEach(function(seg) {
              percents.push(parseFloat(seg.dataset.percent) || 0);
            });

            var cumPercent = 0;
            segs.forEach(function(seg, i) {
              var arc = (percents[i] * e / 100) * C;
              var offset = (cumPercent * e / 100) * C;
              seg.setAttribute('stroke-dasharray', arc + ' ' + (C - arc));
              seg.setAttribute('stroke-dashoffset', -offset);
              cumPercent += percents[i];
            });

            vals.forEach(function(val, i) {
              val.textContent = Math.round(percents[i] * e) + '%';
            });
          }
        });

        if (t < 1) requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trainers"] && !Shopify.designMode) return;
  try {
    
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('trainers__animate--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.trainers__animate').forEach(function (el) {
    observer.observe(el);
  });

  } catch(e) { console.error(e); }
})();
})();
